import React from "react";
import { CalendarBlockParams } from "./CalendarBlockParams.csharp";
import { CalendarBlockTabsView } from "./CalendarBlockTabsView";
import { CalendarBlockFullView } from "./CalendarBlockFullView";
import useWindowSize from "../../../Helpers/useWindowSize";

export const CalendarBlock: React.FC<CalendarBlockParams> = (props) => {
  const { isMobile } = useWindowSize();

  const showTabsView = !props.showLargeDesktopView || (!props.doNotBreakLargeViewOnSmallScreens && isMobile);

  return showTabsView ? <CalendarBlockTabsView {...props} /> : <CalendarBlockFullView {...props} />;
};
